/**
 * Centralized store for user role IDs
 * This file contains all user IDs for special roles/permissions
 */

// Brian's user ID (primary admin)
export const BRIAN_USER_ID = "Py7jBgYDxVTgiP6jVOHb38aDL4F3";

// Group leaders who can trigger @groupleader sound
export const GROUP_LEADERS = [
  "EgjOacAa4vQjR4buKiNBv44k1313",
  "TxqEYcJR6CZrgk3AJ4hMAimcg1C2",
  "dGonqWgnchWPH8l3oCS9f7hbBhI2",
  "kbQt4TAT1DgdB8XFNJTR0If4GHa2",
  "sI3U4Bds5KTb3VJCeDzRUerOD8D2",
  "nnFmJjxE1fRf8DzpVJO4ilW982W2",
  "KAKwCxin7WSjNFg5WT86MZXo5wq2",
];

// Base approved user IDs who can upload files in chat (admins)
export const ADMIN_FILE_UPLOADERS = [
  BRIAN_USER_ID, // Brian
  "5o6pwQ3h37RBXd9bgyJEn94isjf1",
  "UfqmDgywUeQZv67hECqLsUQcoij2",
  "wAKPP5yd4ta9hgYceZ7u9mvbQSw1",
  "svr66Mx1ipXlkrUQyhYCGjVMhbm2",
];

// Combined list of all users who can upload files (admins + group leaders)
export const APPROVED_FILE_UPLOAD_USER_IDS = [
  ...ADMIN_FILE_UPLOADERS,
  ...GROUP_LEADERS,
];

/**
 * Check if a user ID is a group leader
 * @param {string} userId - The user ID to check
 * @returns {boolean}
 */
export const isGroupLeader = (userId) => GROUP_LEADERS.includes(userId);

/**
 * Check if a user ID can upload files
 * @param {string} userId - The user ID to check
 * @returns {boolean}
 */
export const canUserUploadFiles = (userId) =>
  APPROVED_FILE_UPLOAD_USER_IDS.includes(userId);

/**
 * Check if a user ID is allowed to post links in chat.
 * Same trusted set as file uploads (admins + group leaders): everyone else
 * has their messages rendered inert (no clickable links, no URL previews).
 * @param {string} userId - The user ID to check
 * @returns {boolean}
 */
export const canUserPostLinks = (userId) =>
  APPROVED_FILE_UPLOAD_USER_IDS.includes(userId);
